
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[id]",
      function () {
        return require("private-next-pages/docs/[id].js");
      }
    ]);
  